import { render } from "./IntroView.vue?vue&type=template&id=559a39fa"
import script from "./IntroView.vue?vue&type=script&lang=js"
export * from "./IntroView.vue?vue&type=script&lang=js"

import "./IntroView.vue?vue&type=style&index=0&id=559a39fa&lang=css"

import exportComponent from "C:\\wamp64\\www\\police-frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__